import type { ReactNode } from "react";

export function Notice({ children, kind = "info" }: { children: ReactNode; kind?: "info" | "error" | "success" }) {
  return <div className={`flash flash-${kind}`}>{children}</div>;
}
